import classNames from 'classnames';
import * as React from 'react';
const SPOT_SIZE_UNIT = 120;
/**
 * Spot icons are designed to clearly explain the benefit and utility of a product or feature.
 * At 120x120 px, they are the largest of our icon set. Use them when a product illustration might
 * not be appropriate.
 *
 * Example uses: empty states, error states, presentations, sales and marketing moments
 *
 * See
 * [drl/dig/library/components/icons](https://dbx.link/dig/library/components/icons)
 * for more details.
 */
export const SpotIcon = ({ className, 
// `src` is aliased as `IconComponent` for usage in JSX
src: IconComponent, ...rest }) => {
    const cls = classNames('dig-SpotIcon', className);
    const isPresentation = !rest['aria-label'] && !rest['aria-labelledby'];
    return (React.createElement(IconComponent, { className: cls, width: SPOT_SIZE_UNIT, height: SPOT_SIZE_UNIT, focusable: "false", role: isPresentation ? 'presentation' : undefined, ...rest }));
};
SpotIcon.displayName = 'SpotIcon';
